import React, { useState, useCallback, useMemo } from "react";
import { Card, Table, Button, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import {Link} from 'react-router-dom';
import NewPublisherForm from "../forms/newPublisherForm";
import { deletePublisher } from "../../stateManagement/actions/data";

const PublishersList = ({list, reloadData}) => {

    const dispatch = useDispatch();

    // Consolidated modal state management
    const [modalState, setModalState] = useState({
        newPublisher: { visible: false },
        deletePublisher: { visible: false, id: null }
    });

    // Memoized modal handlers to prevent unnecessary recreations
    const showNewPublisherModal = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newPublisher: { visible: true }
        }));
    }, []);

    const handleNewPublisherCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            newPublisher: { visible: false }
        }));
    }, []);

    const showDeletePublisherModal = useCallback((id) => {
        setModalState(prev => ({
            ...prev, 
            deletePublisher: { visible: true, id }
        }));
    }, []);

    const handleDeletePublisherCancel = useCallback(() => {
        setModalState(prev => ({
            ...prev, 
            deletePublisher: { visible: false, id: null }
        }));
    }, []);

    // Memoized columns to prevent unnecessary recreations
    const publishersColumns = useMemo(() => [
        {   
            key: 'returnedValue',
            title: 'Publisher',
            dataIndex: 'returnedValue',
            sorter: (a,b) => a.returnedValue.localeCompare(b.returnedValue)
        },
        {
            key: 'currentValue',
            title: 'Report value',
            dataIndex: 'currentValue',
        },
        {
            key: 'action',
            title: 'Actions',
            render: (data) => (<Button onClick={() => showDeletePublisherModal(data._id)} type="link" danger>Delete</Button>)
        }
    ], [showDeletePublisherModal])

    // Memoized delete handler
    const handleDelete = useCallback(() => {
        dispatch(deletePublisher(modalState.deletePublisher.id));
        reloadData();
        handleDeletePublisherCancel()
    }, [
        dispatch, 
        modalState.deletePublisher.id, 
        reloadData, 
        handleDeletePublisherCancel
    ]);

    return(<>
        <Modal 
            title="Add new publisher" 
            open={modalState.newPublisher.visible} 
            onCancel={handleNewPublisherCancel}
            footer={null}
        >
            <NewPublisherForm reloadData={reloadData}/>
        </Modal>
        <Card title="Publishers list:" size="small" extra={<Link onClick={showNewPublisherModal}>New</Link>}>
            <Table 
                columns={publishersColumns} 
                dataSource={list} 
                rowKey="_id"
                pagination={{
                    showSizeChanger: true,
                    showQuickJumper: true,
                    showTotal: (total) => `Total: ${total}`
                }}
            />            
        </Card>
        <Modal 
            title="Confirmation required" 
            open={modalState.deletePublisher.visible} 
            onCancel={handleDeletePublisherCancel}
            onOk={handleDelete}
        >
            <p>Are you sure?</p>
        </Modal>
    </>)
}

export default PublishersList;